import React from 'react';
import { t } from '@lingui/macro';

import MoreSittersCard from '@rover/components/src/cards/MoreSittersCard/MoreSittersCard';
import { Flex, Heading } from '@rover/kibble/core';
import { SpacingSystemType } from '@rover/kibble/core/styledSystemPropTypes';
import { PageLayout } from '@rover/react-lib/src/components/layouts';
import { useApiPersonRelatedProvidersList } from '@rover/rsdk/src/apiClient/latest/api-person-related-providers-list';

export type Props = {
  sitterOpk: string;
  service?: string;
  searchParams?: string;
};

const MoreSitters = ({ sitterOpk, service, searchParams }: Props): JSX.Element | null => {
  const { data } = useApiPersonRelatedProvidersList(sitterOpk, { service });

  if (!data || data.length === 0) return null;

  return (
    <PageLayout style={{ margin: '0', padding: '0' }} data-testid="more-sitters">
      <Heading size="400" mb="6x">
        {t`More sitters near you`}
      </Heading>
      <Flex
        flexDirection={['column', 'column', 'row']}
        alignItems="start"
        alignSelf="stretch"
        justifyContent="space-around"
      >
        {data.map((provider, i) => {
          const cardProps = {
            firstName: provider.firstName,
            shortName: provider.shortName,
            reviewsCount: provider.reviewsCount,
            ratingsAverage: provider.ratingsAverage,
            webUrl: searchParams ? `${provider.webUrl}?${searchParams}` : provider.webUrl,
            picture: provider.defaultImage.bigThumb,
            location: provider.location,
            isStarSitter: provider.isStarSitter,
          };

          // To get the last element to not have any margin
          const marginBottom: SpacingSystemType = i < data.length - 1 ? ['6x', '6x', '0x'] : '0x';
          const marginRight: SpacingSystemType = i < data.length - 1 ? ['0x', '0x', '12x'] : '0x';

          return (
            <Flex
              key={i}
              flexDirection="column"
              alignSelf="stretch"
              flex="1 0 0"
              background="primary"
              mb={marginBottom}
              mr={marginRight}
            >
              <MoreSittersCard sitter={cardProps} />
            </Flex>
          );
        })}
      </Flex>
    </PageLayout>
  );
};

export default MoreSitters;
